import { AsyncPipe, NgClass, NgTemplateOutlet } from "@angular/common";
import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { FooterComponent } from "@components/footer/footer.component";
import { PageComponent } from "@components/page/page.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { Observable, of } from "rxjs";
import { map, take } from "rxjs/operators";
import { DashboardComponent } from "~app/common/components/dashboard/dashboard.component";
import { RaskRoller } from "~app/common/models/constants";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { FeatureService } from "~app/common/services/feature.service";
import { ValidationMessageRowComponent } from "~app/common/validation/validation-message-row/validation-message-row.component";
import { AktiviteterComponent } from "./aktiviteter/aktiviteter.component";
import { HandelserComponent } from "./handelser/handelser.component";
import { RecentComponent } from "./recent/recent.component";
import * as BoxConfig from "./start.boxes.config";
import { StartInfoBox } from "./start.models";

@Component({
    selector: "rask-start",
    templateUrl: "./start.component.html",
    styleUrls: ["./start.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        TabsComponent,
        TabComponent,
        NgClass,
        NgTemplateOutlet,
        RouterLink,
        RecentComponent,
        HandelserComponent,
        AktiviteterComponent,
        FooterComponent,
        DashboardComponent,
        AsyncPipe,
        ValidationMessageRowComponent
    ]
})
export class StartComponent implements OnInit {
    boxes: StartInfoBox[];
    handelseLabel = "Senaste händelser (0)";
    isfirstPageFeatureActive: boolean;

    protected dashboardFeatureActive: Observable<boolean>;
    private readonly authService = inject(AuthenticationService);
    private readonly featureService = inject(FeatureService);

    getBoxes(): StartInfoBox[] {
        return BoxConfig.default.filter(x => this.authService.hasRoles(x.requiredRoles));
    }

    hasRaskTitta(): boolean {
        return this.authService.hasRole(RaskRoller.role.Titta);
    }

    isBoxActive(box: StartInfoBox) {
        if (box.menu) {
            return this.featureService.getMenuOptionActive(box.menu);
        }
        return of(true);
    }

    ngOnInit(): void {
        const boxes = this.getBoxes();
        this.validateBoxes(boxes);
        this.boxes = boxes;
        this.featureService.getFeatureActive("FirstPage").subscribe(feature => {
            this.isfirstPageFeatureActive = feature;
        });

        this.dashboardFeatureActive = this.featureService.getFeatureActive("Dashboard").pipe(
            map(feature => feature && this.authService.hasRole(RaskRoller.role.Virkeskopa))
        );
    }

    setNrOfErrors(event: number) {
        this.handelseLabel = `Senaste händelser (${event})`;
    }

    validateBoxes(boxes: StartInfoBox[]) {
        boxes.forEach(box => this.isBoxActive(box)
            .pipe(take(1))
            .subscribe(active => box.isActive = active));
    }
}
